import React from 'react';
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia } from '../../components/imports';

const Content = () => {

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>
          <MotionContent height={'some h-[120vh]='} className={"aspect-square"}>
            <ImageMedia
              key={"OmanaHeroImage"}
              src={require('./assets/NV_Stationery.jpg')}
              className="relative md:landscape:scale-[120%] full object-cover object-top"
            />
          </MotionContent>
        </div>
      )}
    </ThisProject>
  )
}

export default Content